var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "settings_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#settings_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.345 26c-.45 0-.838-.15-1.163-.45-.325-.3-.52-.667-.587-1.1l-.225-1.65a3.79 3.79 0 01-.612-.3 8.25 8.25 0 01-.563-.375l-1.55.65c-.417.183-.833.2-1.25.05a1.843 1.843 0 01-.975-.8l-1.175-2.05a1.587 1.587 0 01-.2-1.225c.1-.433.325-.792.675-1.075l1.325-1a2.387 2.387 0 01-.025-.338v-.675c0-.108.008-.22.025-.337l-1.325-1a1.897 1.897 0 01-.675-1.075c-.1-.433-.033-.842.2-1.225l1.175-2.05c.233-.383.558-.65.975-.8.417-.15.833-.133 1.25.05l1.55.65c.183-.133.375-.258.575-.375.2-.117.4-.217.6-.3l.225-1.65c.067-.433.262-.8.587-1.1.325-.3.713-.45 1.163-.45h2.35c.45 0 .837.15 1.163.45.325.3.52.667.587 1.1l.225 1.65c.217.083.42.183.612.3.192.117.38.242.563.375l1.55-.65c.417-.183.833-.2 1.25-.05.417.15.742.417.975.8l1.175 2.05c.233.383.3.792.2 1.225-.1.433-.325.792-.675 1.075l-1.325 1c.017.117.025.23.025.338v.674c0 .109-.017.221-.05.338l1.325 1c.35.283.575.642.675 1.075.1.433.033.842-.2 1.225l-1.2 2.05c-.233.383-.558.65-.975.8-.417.15-.833.133-1.25-.05l-1.5-.65a6.826 6.826 0 01-.575.375c-.2.117-.4.217-.6.3l-.225 1.65c-.067.433-.262.8-.587 1.1-.326.3-.713.45-1.163.45h-2.35zm1.225-6.5c.967 0 1.792-.342 2.475-1.025A3.372 3.372 0 0019.07 16c0-.967-.342-1.792-1.025-2.475A3.372 3.372 0 0015.57 12.5c-.983 0-1.813.342-2.488 1.025A3.393 3.393 0 0012.07 16c0 .967.338 1.792 1.012 2.475.675.683 1.505 1.025 2.488 1.025z",
    fill: "#fff"
  }))));
}
export default SvgSettings;